<template>
  <v-app class="bckgrnd">
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-card class="form-container" style="border:1px solid">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12>
            <v-switch v-model="edit" label="Want to edit ?" color="primary" hide-details></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-text-field :disabled="edit === false" v-model="form.name" label="Training Type *" :rules="emptyRule" required></v-text-field>
          </v-flex>

          <v-flex xs12 style="text-align:right">
            <v-btn :disabled="edit === false" depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
            <v-btn :disabled="edit === false" depressed color="orange" dark @click="back()">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create user",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      edit: false,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required."
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Training Type",
          disabled: false,
          to: "/trainingType"
        },
        {
          text: "Edit",
          disabled: true,
          to: "/createTrainingType"
        }
      ],
      roleTypes: null,
      selectedRoleType: null,

      form: {
        name: null
      }
    };
  },

  mounted() {
      this.axios
      .get(config.API + `TrainingTypes/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
      });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `TrainingTypes/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),
              name: this.form.name
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Training type successfully updated");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
</style>
